export default __webpack_public_path__ + "static/urgenceschrono-2bff60fe835a4bef75282cb778fbea73.png";